<template>
    <base-button @click="ShowModal()" type="primary" class="my-0 btn" simple icon><i class="d-inline-block tim-icons icon-settings-gear-63"></i></base-button>
</template>
<script>
import ReConfig from './ReConfig.vue';

export default {
    name:'ReConfigButton',
    data(){
        return {};
    },
    props:{
        obj: String,
        title: {
            type: String,
            default: 'Настройка модуля',
        },
    },
    methods:{
        ShowModal(props){
            // console.log('obj', this.obj);
            this.$modal(ReConfig,{title:this.title, props:{obj:this.obj}});
        }
    }
}
</script>
<style lang="scss" scoped>
</style>